import { inject, injectable } from 'inversify';
import 'reflect-metadata';

import { TYPES as ApiGatewayTypes, HttpResponse, IApiGateway } from '@desygner/ui-core-api-gateway';

export type { UserData, MembershipData } from './user.types';

export interface IUserService {
  getUserInfo(): Promise<HttpResponse>;
  getMembership(): Promise<HttpResponse>;
  refreshToken(): Promise<HttpResponse>;
}

@injectable()
export class UserService implements IUserService {
  constructor(
    @inject(ApiGatewayTypes.ApiGateway)
    private readonly apiGateway: IApiGateway,
    private readonly apiGatewayInstance?: string | null
  ) {
    this.apiGatewayInstance = apiGatewayInstance;
  }

  async getUserInfo(): Promise<HttpResponse> {
    /**
     * Due to a CORS issue on the mobile app, we need to use Fluer API for Fluer users
     * and Desygner API for Desygner users for this particular endpoint.
     * Thread: https://desygner-team.slack.com/archives/C081PSQLQ5A/p1732668475558169
     */
    const apiGateway = this.apiGatewayInstance
      ? this.apiGateway.use(this.apiGatewayInstance)
      : this.apiGateway;

    return await apiGateway.fetch('GET', 'business/users/me');
  }

  async getMembership(): Promise<HttpResponse> {
    return await this.apiGateway.fetch(
      'GET',
      `brand/companies/${this.apiGateway.company}/memberships/me`
    );
  }

  async refreshToken(): Promise<HttpResponse> {
    return await this.apiGateway.use('auth').fetch('POST', 'api/refresh-token');
  }
}

export const TYPES = {
  UserService: Symbol('UserService'),
};
